<template>
  <div
    v-if="notificationOpen"
    class="flex flex-col w-full gap-2 bg-white rounded-lg"
  >
    <div
      role="alert"
      class="relative flex w-full px-4 py-4 text-base text-red-900 bg-opacity-20 bg-red-900 rounded-lg font-regular"
      data-dismissible="alert"
    >
      <div class="mr-12 text-sm py-2 w-full flex">
        <span
          class="flex gap-2 landscape:items-center items-start justify-between w-full"
        >
          <div
            class="flex justify-center landscape:items-center items-start mr-2"
          >
            <i class="fa-solid fa-circle-info text-[20px] mr-2"></i> You are yet
            to verify your email. Please check your mailbox for the verification
            email or
          </div>
          <button
            class="bg-white border-0 p-2 text-xs font-medium text-left text-main-600 align-middle transition-all rounded-lg select-none disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none hover:bg-white-900/10 active:bg-white-900/20 w-min"
            @click="resendMyVerification"
          >
            Resend verification
          </button></span
        >
      </div>
      <button
        @click="handelNotification"
        data-dismissible-target="alert"
        class="!absolute top-3 right-3 h-8 max-h-[32px] w-8 max-w-[32px] select-none rounded-lg text-center align-middle text-xs font-medium uppercase text-main-900 transition-all hover:bg-white/30 active:bg-white/40 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
        type="button"
      >
        <span
          class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
          ><i class="fa-solid fa-xmark text-[18px]"></i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  name: "StartUpAlert",
  data() {
    return {
      notificationOpen: this.$store.state.isEmailVerified || false,
    };
  },
  methods: {
    ...mapActions(["resendVerification"]),
    handelNotification() {
      this.notificationOpen = !this.notificationOpen;
      this.$emit("close");
    },
    async resendMyVerification() {
      const response = await this.resendVerification();
      if (response.success) {
        toast.success(response.message, {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        toast.error(response.message, {
          position: "top-right",
          autoClose: 3000,
        });
      }
    },
  },
};
</script>
